import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  -webkit-tap-highlight-color: transparent;

  * {
    font-family: system-ui, "Open Sans", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji";
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
  }
`

export default Container